// src/hooks/useOutsideClick.js
import { useEffect } from 'react';

function useOutsideClick(ref, callback) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }
    // Ajoute l'écouteur d'événement
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Nettoie l'écouteur
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
}

export default useOutsideClick;